import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'list-stats',
	templateUrl: './list-stats.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class ListStatsComponent implements OnInit {
	
	@Input() stats: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		
	}
	
}